import { bl_fi_cfg_fiscal_period_event_RowClass } from '../../../dbschema/bl_fi_cfg_fiscal_period_event.model';
import { bl_fi_cfg_fiscal_period_ext_RowClass } from '../../../dbschema/bl_fi_cfg_fiscal_period_ext.model';
import { bl_fi_cfg_fiscal_period_hdr_RowClass } from '../../../dbschema/bl_fi_cfg_fiscal_period_hdr.model';
import { bl_fi_cfg_fiscal_year_hdr_RowClass } from '../../../dbschema/bl_fi_cfg_fiscal_year_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class FiscalYearContainerModel extends BaseContainerModel {
  bl_fi_cfg_fiscal_year_hdr: bl_fi_cfg_fiscal_year_hdr_RowClass = new bl_fi_cfg_fiscal_year_hdr_RowClass();
  bl_fi_cfg_fiscal_period_hdrs: bl_fi_cfg_fiscal_period_hdr_RowClass[] = [];
  bl_fi_cfg_fiscal_period_events: bl_fi_cfg_fiscal_period_event_RowClass[] = [];
  bl_fi_cfg_fiscal_period_exts: bl_fi_cfg_fiscal_period_ext_RowClass[] = [];
}
